import { PATH_TO_SOURCE_MAPPINGS } from "lib/constants";

/**
 * Sanitizes a path by removing extraneous query parameters.
 */
function sanitizePath(path: string): string {
  return path.split("?")[0];
}

/**
 * Converts a generic path (i.e. /foo/bar) to a RegEx (i.e. /^\/foo\/bar$/).
 */
function convertPathToRegExp(path: string | RegExp): RegExp {
  if (path instanceof RegExp) return path;

  const escapedPath = path.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&");

  return new RegExp(`^${escapedPath}$`);
}

/**
 * Returns a source from the provided path by attempting to locate the source
 * from a mapping of strings and expressions (defined in MAPPED_PATHS), falling
 * back to simply the provided path as the source when no mapping was found.
 */
export function getSource(path: string): string {
  const sanitizedPath = sanitizePath(path);

  for (const pathMapping of PATH_TO_SOURCE_MAPPINGS) {
    const { path: mappedPath, source: mappedSource } = pathMapping;
    const mappedPathExpression = convertPathToRegExp(mappedPath);
    const matches = mappedPathExpression.exec(sanitizedPath);

    if (matches) {
      return sanitizedPath.replace(mappedPath, mappedSource);
    }
  }

  return sanitizedPath;
}
